import { iContent } from '@/Engine/apiInterfaces';
import { Item } from '@/Engine/Item';
import { Vector3 } from 'three';
import { $ } from '@/Engine/state';
import { changeTextureCustom } from '@/Engine/changeTexture';

export class GridShelf extends Item {

    constructor(props: iContent, color: string,  width: 300 | 400, isAddSection: boolean) {
        super(props);
        this.setColor(color);
        this.position = new Vector3(0, 0, 0);

        const aoPath = 'AO/' + width + '/Polka/polka_grid_' + (isAddSection?'0':'') + width + '_AO.jpg';
        console.log('polka grid  ao: ' + aoPath);
        $.textureLoader
            .loadAsync(aoPath)
            .then((texture)=>{
                changeTextureCustom(this._model.material, 'AO', texture);
            })
            .catch((err)=>{
                console.log(aoPath);
                console.error(err);
            });
    }
}
